<template lang="pug">
    div(id="sliderWidget")
        v-layout(mx-2 align-center justify-space-between row)
            span(v-text="timestamp_text")
            v-flex(ml-2)
                input(:id="name"
                      type="range" 
                      min=0
                      :max="sliderMaxi"
                      @input="onValueChanged")
</template>


<script>
export default {
    /* global */
    props: {
        sliderMaxi: Number,
        labels: Array,
        initial_value: Number,
        name: String
    },

    data: () => ({
        timestamp_text: "",
    }),

    mounted() {
      document.getElementById(this.name).value = this.initial_value;
      this.$emit('valueChanged', Number(this.initial_value));
      this.timestamp_text = this.labels[this.initial_value];
    },

    created() {
    },

    computed: {
    },

     watch: {
    },

    methods: {        
        onValueChanged(value) {
            this.$emit('valueChanged', Number(value.target.value));
            this.timestamp_text = this.labels[value.target.value];
        },
    },
}
</script>

<style scoped>
input[type=range] {
  vertical-align: middle;
  height: 32px;
  -webkit-appearance: none;
  margin: 10px 0;
  width: 100%;
}
input[type=range]:focus {
  outline: none;
}
input[type=range]::-webkit-slider-runnable-track {
  width: 100%;
  height: 5px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 0px 0px 0px #000000;
  background: #2497E3;
  border-radius: 1px;
  border: 0px solid #000000;
}
input[type=range]::-webkit-slider-thumb {
  box-shadow: 0px 0px 0px #000000;
  border: 1px solid #2497E3;
  height: 25px;
  width: 25px;
  border-radius: 25px;
  background: #A1D0FF;
  cursor: pointer;
  -webkit-appearance: none;
  margin-top: -10.5px;
}
input[type=range]:focus::-webkit-slider-runnable-track {
  background: #2497E3;
}
input[type=range]::-moz-range-track {
  width: 100%;
  height: 5px;
  cursor: pointer;
  animate: 0.2s;
  box-shadow: 0px 0px 0px #000000;
  background: #2497E3;
  border-radius: 1px;
  border: 0px solid #000000;
}
input[type=range]::-moz-range-thumb {
  box-shadow: 0px 0px 0px #000000;
  border: 1px solid #2497E3;
  height: 25px;
  width: 25px;
  border-radius: 25px;
  background: #A1D0FF;
  cursor: pointer;
}
input[type=range]::-moz-focus-outer {
  border: 0;
}
input[type=range]::-ms-track {
  width: 100%;
  height: 5px;
  cursor: pointer;
  animate: 0.2s;
  background: transparent;
  border-color: transparent;
  color: transparent;
}
input[type=range]::-ms-fill-lower {
  background: #2497E3;
  border: 0px solid #000000;
  border-radius: 2px;
  box-shadow: 0px 0px 0px #000000;
}
input[type=range]::-ms-fill-upper {
  background: #2497E3;
  border: 0px solid #000000;
  border-radius: 2px;
  box-shadow: 0px 0px 0px #000000;
}
input[type=range]::-ms-thumb {
  margin-top: 1px;
  box-shadow: 0px 0px 0px #000000;
  border: 1px solid #2497E3;
  height: 25px;
  width: 25px;
  border-radius: 25px;
  background: #A1D0FF;
  cursor: pointer;
}
input[type=range]:focus::-ms-fill-lower {
  background: #2497E3;
}
input[type=range]:focus::-ms-fill-upper {
  background: #2497E3;
}



</style>
